import React, { useState } from "react";
import { Box, Grid, Typography, Button, MenuItem } from "@mui/material";
import styles from "./HomeNew.module.css";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/Latest Logo.png";
import Footer from "./HomeFooter";
import { IoHomeOutline } from "react-icons/io5";
import { PiBookOpenUser } from "react-icons/pi";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { GoLightBulb } from "react-icons/go";
import { RxHamburgerMenu } from "react-icons/rx";
import Fade from "react-reveal/Fade";
import { customTextColor } from "../../utils/const";

const Website = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <Box>
      <Box className={styles.home_header}>
        <span>
          <img src={logo} alt="Logo" />
        </span>
        <span className={styles.nav_links}>
          <a onClick={() => navigate("/")}>
            <IoHomeOutline style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Home
            </b>
          </a>

          <a onClick={() => navigate("/our-platform")}>
            <GoLightBulb style={{ fontSize: "18px" }} />
            <b
              style={{
                marginLeft: "5px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Our Platform
            </b>
          </a>
          <a onClick={() => navigate("/about-us")}>
            <PiBookOpenUser style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              About us
            </b>
          </a>
          <a onClick={() => navigate("/contact-us")}>
            <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Contact us
            </b>
          </a>
          <Box className={styles.login_btn}>
            <a onClick={() => navigate("/login")}>
              <b>Login</b>
            </a>
          </Box>
        </span>

        {/* Hamburger menu for mobile view */}
        <span className={styles.hamburger_icon} onClick={toggleMenu}>
          <RxHamburgerMenu style={{ fontSize: "30px" }} />
        </span>

        {/* Mobile Menu */}
        {menuOpen && (
          <Box className={styles.mobile_menu}>
            <a onClick={() => navigate("/")}>
              <IoHomeOutline style={{ fontSize: "22px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Home
              </Typography>
            </a>

            <a onClick={() => navigate("/our-platform")}>
              <GoLightBulb style={{ fontSize: "20px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Our Platform
              </Typography>
            </a>
            <a onClick={() => navigate("/about-us")}>
              <PiBookOpenUser style={{ fontSize: "22px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                About us
              </Typography>
            </a>
            <a onClick={() => navigate("/contact-us")}>
              <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Contact us
              </Typography>
            </a>
            <Box className={styles.login_btn}>
              <a onClick={() => navigate("/login")}>
                <b>Login</b>
              </a>
            </Box>
          </Box>
        )}
      </Box>
      <Box sx={{ padding: "35px" }} id="home" />
      <Box className={styles.home_structure}>
        <Fade bottom delay={200}>
          <Box className={styles.configuration_structure}>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={4}
                md={3}
                sx={{ backgroundColor: "#fff", border: "2px solid #f2f2f2" }}
              >
                <Box className={styles.security_body}>
                  <Box
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{
                      color: customTextColor,
                      fontSize: "17px !important",
                      margin: "4px 0",
                    }}
                    onClick={() => navigate("/privacy-policy")}
                  >
                    <b>Privacy Policy</b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/refund-policy")}
                >
                  <Box
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Refund Policy</b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/term-of-use")}
                >
                  <Box
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                     <b style={{ borderBottom: "2px solid #1991e0" }}>Website Terms of Use</b>
                  </Box>
                </Box>

                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/data-backup-policy")}
                >
                  <Box
                    aria-controls="panel2-content"
                    id="panel2-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Data Backup Policy</b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/safe-job-search")}
                >
                  <Box
                    aria-controls="panel2-content"
                    id="panel2-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Safe Job Search & Applies Security </b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  onClick={() => navigate("/reporting-fraud")}
                  style={{ margin: "14px 0" }}
                >
                  <Box
                    aria-controls="panel3-content"
                    id="panel3-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Reporting fraud</b>
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={8}
                md={9}
                style={{
                  paddingLeft: window.innerWidth < 600 ? "15px" : "0",
                }}
              >
                <Box className={styles.employer_details}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{
                      padding: "10px 30px 55px 20px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{ fontSize: "20px !important", userSelect: "none" }}
                      >
                        <b>Website Terms of Use</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Effective date: February 3, 2024
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Welcome to https://www.Povital.com/ (the “Site”), owned
                        and operated by Povital Corp. (“Povital,” “we,” or
                        “us”). By using this Site, you agree to these terms and
                        conditions of use (the “Terms”); if you do not agree,
                        you may not use the Site. Povital may modify the Site
                        and/or these Terms from time to time without notice to
                        you, except that if Povital makes material changes to
                        these Terms, we will post the revised Terms and the
                        revised effective on this Site and/or provide notice by
                        some other means. By using the Site following any
                        modifications to the Terms, you agree to be bound by the
                        modified Terms. The Terms do not govern use of any of
                        Povital’s services, which are subject to a separate
                        services agreement to be signed between any user of the
                        services and Povital. These Terms include the provisions
                        in this document as well as those in the{" "}
                        <b style={{ textDecoration: "underline" }}>
                          Privacy Policy
                        </b>
                        , and any other relevant policies.{" "}
                        <b>
                          Your use of or participation in certain Services may
                          also be subject to additional policies, rules and/or
                          conditions (“Additional Terms”), which are
                          incorporated herein by reference, and you understand
                          and agree that by using or participating in any such
                          Services, you agree to also comply with these
                          Additional Terms.
                        </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b> Please read these Terms carefully.</b>
                        They cover important information about Services provided
                        to you.
                        <b>
                          These Terms include information about future changes
                          to these Terms, limitations of liability, a class
                          action waiver and resolution of disputes by
                          arbitration instead of in court. PLEASE NOTE THAT YOUR
                          USE OF AND ACCESS TO OUR SERVICES ARE SUBJECT TO THE
                          FOLLOWING TERMS; IF YOU DO NOT AGREE TO ALL OF THE
                          FOLLOWING, YOU MAY NOT USE OR ACCESS THE SERVICES IN
                          ANY MANNER.
                        </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>ARBITRATION NOTICE AND CLASS ACTION WAIVER: </b>{" "}
                        EXCEPT FOR CERTAIN TYPES OF DISPUTES DESCRIBED IN THE
                        ARBITRATION AGREEMENT SECTION BELOW, YOU AGREE THAT
                        DISPUTES BETWEEN YOU AND US WILL BE RESOLVED BY BINDING,
                        INDIVIDUAL ARBITRATION AND YOU WAIVE YOUR RIGHT TO
                        PARTICIPATE IN A CLASS ACTION LAWSUIT OR CLASS-WIDE
                        ARBITRATION.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li style={{ listStyle: "none" }}>
                            <b> 1. Use of the Site.</b> You must be at least 16
                            years old to use our Site. We do not knowingly
                            collect or solicit personally identifiable
                            information from individuals under 16. If you are
                            under 16, please do not attempt to use the Site or
                            send any personal information about yourself to us.
                            If we learn we have collected personal information
                            from an individual under 16, we will de lete that
                            information as quickly as possible. You will comply
                            with all applicable laws, rules and regulations in
                            connection with your use of the Site. You will not
                            violate or attempt to violate the security of the
                            Site or Povital’s systems or network security,
                            including, without limitation by (i) accessing data
                            not intended for users of the Site or gaining
                            unauthorized access to an account, server or any
                            other computer system; (ii) attempting to probe,
                            scan or test the vulnerability of a system or
                            network or to breach security or authentication
                            measures; (iii) attempting to interfere with the
                            function of the Site, host or network. You may not
                            “crawl,” “scrape,” or “spider” any portion of the
                            Site (through use of manual or automated means).
                          </li>
                          <li style={{ listStyle: "none" }}>
                            <b> 2. Information Not Confidential.</b> If you
                            choose to contact any Povital personnel using the
                            contact information you find on the Site, you
                            understand any information and/or materials you
                            provide to such personnel will not be treated as
                            confidential or proprietary. Povital undertakes no
                            obligation to review information submitted by you,
                            or to return such information to you.
                          </li>

                          <li style={{ listStyle: "none" }}>
                            <b> 3. Povital Proprietary Rights.</b> The Site,
                            including all of its contents (including, text,
                            images, audio, and the HTML used to generate the
                            pages) (“Content”), are the property of Povital or
                            that of our suppliers or licensors and are protected
                            trademark, copyright, and/or other intellectual
                            property laws. You may not download, copy, print,
                            display, perform, reproduce, publish, modify,
                            prepare derivative works from, license, transmit, or
                            distribute any Content from this Site in whole or in
                            part, for any public or commercial purpose without
                            prior written consent from Povital. Povital grants
                            you a limited, personal, non-exclusive,
                            non-transferable license to access the Site, and to
                            use the Content, solely for personal, internal and
                            non-commercial purposes. Povital (on behalf of
                            itself and its suppliers and licensors) reserves all
                            rights not expressly granted herein. If you provide
                            us (in a direct email or otherwise) with any
                            feedback, suggestions, improvements, enhancements,
                            and/or feature requests relating to the Services
                            (each of the foregoing, “Feedback”), Povital will
                            own all such Feedback and you hereby assign to
                            Povital all your rights to such feedback.
                          </li>
                          <Typography
                            sx={{
                              fontSize: "16px !important",
                              marginTop: "15px",
                              userSelect: "none",
                            }}
                          >
                            Without limiting the foregoing, as between you and
                            Povital, Povital is the owner and/or authorized user
                            of any trademark, registered trademark, logo, and/or
                            service mark appearing on the Site (the “Marks”).
                            Nothing on the Site should be construed to grant any
                            license or right to use any Povital Mark. You may
                            not use or exploit any Marks without prior written
                            consent from Povital.
                          </Typography>
                          <li style={{ listStyle: "none" }}>
                            <b> 4. Links from and to the Site.</b> The Site may
                            contain links to third party websites (“Third Party
                            Sites”). Third Party Sites are not reviewed,
                            controlled or examined by Povital in any way and
                            Povital is not responsible for any content contained
                            therein. These links do not imply Povital’s
                            endorsement of or association with any Third-Party
                            Site. Povital is not liable, directly or indirectly,
                            to anyone for any loss or damage arising from or in
                            connection with use of the ThirdParty Sites.
                          </li>
                          <li style={{ listStyle: "none" }}>
                            <b>5. Disclaimer of Warranties.</b> THE SITE,
                            INCLUDING, WITHOUT LIMITATION, ALL CONTENT AND
                            FUNCTIONALITY THEREOF, IS PROVIDED “AS IS,” WITHOUT
                            WARRANTY OF ANY KIND, INCLUDING, WITHOUT LIMITATION,
                            ANY WARRANTIES OF AVAILABILITY, ACCURACY,
                            COMPLETENESS, USEFULNESS, TITLE, NON-INFRINGEMENT,
                            MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE,
                            AND POVITAL (ON BEHALF OF ITSELF AND ITS SUPPLIERS
                            AND LICENSORS) HEREBY DISCLAIMS ANY AND ALL
                            WARRANTIES, EXPRESS OR IMPLIED. NO ADVICE, RESULTS,
                            INFORMATION OR MATERIALS, WHETHER ORAL OR WRITTEN,
                            OBTAINED BY YOU THROUGH THE SITE WILL CREATE ANY
                            WARRANTY NOT EXPRESSLY MADE HEREIN.
                          </li>
                          <li style={{ listStyle: "none" }}>
                            <b>6. Limitation of Liability.</b> TO THE GREATEST
                            EXTENT PERMITTED UNDER APPLICABLE LAW, IN NO EVENT
                            WILL POVITAL, ITS AFFILIATES (INCLUDING AFFILIATED
                            FUNDS) OR ANY OF ITS OR THEIR RESPECTIVE DIRECTORS,
                            OFFICERS, EMPLOYEES, AGENTS, SUPPLIERS OR LICENSORS
                            (THE “POVITAL PARTIES”), BE LIABLE FOR ANY INDIRECT,
                            SPECIAL, INCIDENTAL, CONSEQUENTIAL, EXEMPLARY OR
                            PUNITIVE DAMAGES ARISING FROM OR IN CONNECTION WITH
                            THE USE OF, OR THE INABILITY TO USE, THE SITE OR THE
                            CONTENT, EVEN IF ANY POVITAL PARTY HAS BEEN ADVISED
                            OF THE POSSIBILITY OF SUCH DAMAGES. SOME
                            JURISDICTIONS DO NOT ALLOW THE LIMITATION OR
                            EXCLUSION OF LIABILITY SO SOME OF THE ABOVE
                            LIMITATIONS MAY NOT APPLY TO YOU. IN NO EVENT WILL
                            THE TOTAL LIABILITY OF ANY POVITAL PARTY TO YOU FOR
                            ALL DAMAGES, LOSSES, AND CAUSES OF ACTION (WHETHER
                            IN CONTRACT OR TORT, INCLUDING, BUT NOT LIMITED TO,
                            NEGLIGENCE OR OTHERWISE) ARISING FROM OR RELATED TO
                            THE TERMS, THE CONTENT, AND/OR YOUR USE OF THE SITE,
                            EXCEED, IN THE AGGREGATE, $100.00.
                          </li>
                          <li style={{ listStyle: "none" }}>
                            <b>7. Choice of Law and Arbitration.</b>
                          </li>
                          <ul>
                            <li style={{ listStyle: "none" }}>
                              1. Choice of Law. These Terms are governed by and
                              will be construed under the Federal Arbitration
                              Act, applicable federal law, and the laws of the
                              State of New York, without regard to the conflicts
                              of laws provisions thereof.
                            </li>
                            <li style={{ listStyle: "none" }}>
                              2. Arbitration Agreement. Please read the
                              following ARBITRATION AGREEMENT carefully because
                              it requires you to arbitrate certain disputes and
                              claims with Povital and limits the manner in which
                              you can seek relief from Povital. Both you and
                              Povital acknowledge and agree that for the
                              purposes of any dispute arising out of or relating
                              to the subjec t matter of these Terms, Povital’s
                              officers, directors, employees and independent
                              contractors (“Personnel”) are third-party
                              beneficiaries of these Terms, and that upon your
                              acceptance of these Terms, Personnel will have the
                              right (and will be deemed to have accepted the
                              right) to enforce these Terms against you as the
                              third-party beneficiary hereof.
                            </li>
                            <li
                              style={{ listStyle: "none", marginTop: "15px" }}
                            >
                              (a) Arbitration Rules; Applicability of
                              Arbitration Agreement. The parties shall use their
                              best efforts to settle any dispute, claim,
                              question, or disagreement arising out of or
                              relating to the subject matter of these Terms
                              directly through good-faith negotiations, which
                              shall be a precondition to either party initiating
                              arbitration. If such negotiations do not resolve
                              the dispute, it shall be finally settled by
                              binding arbitration in Monroe County, New York.
                              The arbitration will proceed in the English
                              language, in accordance with the JAMS Streamlined
                              Arbitration Rules and Procedures (the “Rules”)
                              then in effect, by one commercial arbitrator with
                              substantial experience in resolving intellectual
                              property and commercial contract disputes. The
                              arbitrator shall be selected from the appropriate
                              list of JAMS arbitrators in accordance with such
                              Rules. Judgment upon the award rendered by such
                              arbitrator may be entered in any court of
                              competent jurisdiction.
                            </li>
                            <li
                              style={{ listStyle: "none", marginTop: "15px" }}
                            >
                              (b) Costs of Arbitration. The Rules will govern
                              payment of all arbitration fees. Povital will pay
                              all arbitration fees for claims less than
                              seventy-five thousand ($1,000) dollars. Povital
                              will not seek its attorneys’ fees and costs in
                              arbitration unless the arbitrator determines that
                              your claim is frivolous.
                            </li>
                            <li
                              style={{ listStyle: "none", marginTop: "15px" }}
                            >
                              (c) Small Claims Court; Infringement. Either you
                              or Povital may assert claims, if they qualify, in
                              small claims court in Monroe County, New York or
                              any United States county where you live or work.
                              Furthermore, notwithstanding the foregoing
                              obligation to arbitrate disputes, each party shall
                              have the right to pursue injunctive or other
                              equitable relief at any time, from any court of
                              competent jurisdiction, to prevent the actual or
                              threatened infringement, misappropriation or
                              violation of a party’s copyrights, trademarks,
                              trade secrets, patents or other intellectual
                              property rights.
                            </li>
                            <li
                              style={{ listStyle: "none", marginTop: "15px" }}
                            >
                              (d) Waiver of Jury Trial. YOU AND POVITAL WAIVE
                              ANY CONSTITUTIONAL AND STATUTORY RIGHTS TO GO TO
                              COURT AND HAVE A TRIAL IN FRONT OF A JUDGE OR
                              JURY. You and Povital is instead choosing to have
                              claims and disputes resolved by arbitration.
                              Arbitration procedures are typically more limited,
                              more efficient, and less costly than rules
                              applicable in court and are subject to very
                              limited review by a court. In any litigation
                              between you and Povital over whether to vacate or
                              enforce an arbitration award, YOU AND POVITAL
                              WAIVE ALL RIGHTS TO A JURY TRIAL, and elect
                              instead to have the dispute be resolved by a
                              judge.
                            </li>
                            <li
                              style={{ listStyle: "none", marginTop: "15px" }}
                            >
                              (e) Waiver of Class or Consolidated Actions.
                              EXCEPT TO THE EXTENT ARISING OUT OF THE UNITED
                              STATES OF AMERICA CONSUMER PRIVACY ACT, ALL CLAIMS
                              AND DISPUTES WITHIN THE SCOPE OF THIS ARBITRATION
                              AGREEMENT MUST BE ARBITRATED OR LITIGATED ON AN
                              INDIVIDUAL BASIS AND NOT ON A CLASS BASIS. CLAIMS
                              OF MORE THAN ONE CUSTOMER OR USER CANNOT BE
                              ARBITRATED OR LITIGATED JOINTLY OR CONSOLIDATED
                              WITH THOSE OF ANY OTHER CUSTOMER OR USER. If
                              however, this waiver of class or consolidated
                              actions is deemed invalid or unenforceable,
                              neither you nor Povital is entitled to
                              arbitration; instead all claims and disputes will
                              be resolved in a court as set forth in (g) below.
                            </li>
                            <li
                              style={{ listStyle: "none", marginTop: "15px" }}
                            >
                              (g) Exclusive Venue. If you send the opt-out
                              notice in (f), and/or in any circumstances where
                              the foregoing arbitration agreement permits either
                              you or Povital to litigate any dispute arising out
                              of or relating to the subject matter of these
                              Terms in court, then the foregoing arbitration
                              agreement will not apply to either party, and both
                              you and Pov ital agree that any judicial
                              proceeding (other than small claims actions) will
                              be brought in the state or federal courts located
                              in, respectively, Monroe County, New York, or the
                              federal district in which that county falls.
                            </li>
                            <li
                              style={{ listStyle: "none", marginTop: "15px" }}
                            >
                              (h) Severability. If the prohibition against class
                              actions and other claims brought on behalf of
                              third parties contained above is found to be
                              unenforceable, then all of the preceding language
                              in this Arbitration Agreement section will be null
                              and void. This arbitration agreement will survive
                              the termination of your relationship with Povital.
                            </li>
                          </ul>
                          <li style={{ listStyle: "none", marginTop: "15px" }}>
                            <b>8. General Information.</b> The failure of
                            Povital to exercise or enforce any right or
                            provision of these Terms does not constitute a
                            waiver of such right or provision. If any provision
                            of these Terms is found by a court of competent
                            jurisdiction to be invalid, that provision will be
                            limited or eliminated, to the minimum extent
                            necessary, so that these Terms shall otherwise
                            remain in full force and effect and enforceable. You
                            may not assign these Terms or transfer any of your
                            rights or obligations hereunder without Povital’s
                            express written consent. These Terms inure to the
                            benefit of Povital’s successors, assigns and
                            licensees. These Terms are the entire agreement
                            between you and Povital with respect to the subject
                            matter herein.
                          </li>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>Contact Us.</b> If you have any questions, comments,
                        or concerns regarding these terms or the Services,
                        please contact us at:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Email: compliance@povital.com
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>Anti-Spam Guidance</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>A Compliance Guide for Business</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Do you use email in your business? The CAN-SPAM Act, a
                        law that sets the rules for commercial email,
                        establishes requirements for commercial messages, gives
                        recipients the right to have you stop emailing them, and
                        spells out tough penalties for violations.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Despite its name, the CAN-SPAM Act doesn’t apply just to
                        bulk email. It covers all commercial messages, which the
                        law defines as “any electronic mail message the primary
                        purpose of which is the commercial advertisement or
                        promotion of a commercial product or service,” including
                        email that promotes content on commercial websites. The
                        law makes no exception for business-to-business email.
                        That means all email – for example, a message to former
                        customers announcing a new product line – must comply
                        with the law.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Each separate email in violation of the CAN-SPAM Act is
                        subject to penalties of up to $41,484, so noncompliance
                        can be costly. But following the law isn’t complicated.
                        Here’s a rundown of CAN-SPAM’s main requirements:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li>
                            <b>
                              Don’t use false or misleading header information:
                            </b>{" "}
                            Your “From,” “To,” “Reply-To,” and routing
                            information – including the originating domain name
                            and email address – must be accurate and identify
                            the person or business who initiated the message.
                          </li>
                          <li>
                            <b>Don’t use deceptive subject lines: </b> The
                            subject line must accurately reflect the content of
                            the message.
                          </li>
                          <li>
                            <b>Identify the message as an ad: </b> The law gives
                            you a lot of leeway in how to do this, but you must
                            disclose clearly and conspicuously that your message
                            is an advertisement.
                          </li>
                          <li>
                            <b>Tell recipients where you’re located: </b> Your
                            message must include your valid physical postal
                            address. This can be your current street address, a
                            post office box you’ve registered with the U.S.
                            Postal Service, or a private mailbox you’ve
                            registered with a commercial mail receiving agency
                            established under Postal Service regulations.
                          </li>
                          <li>
                            <b>
                              Tell recipients how to opt out of receiving future
                              email from you:{" "}
                            </b>{" "}
                            Your message must include a clear explanation of how
                            the recipient can opt out of getting email from you
                            in the future. Craft the notice in a way that’s easy
                            for an ordinary person to recognize, read, and
                            understand. Creative use of type size, color, and
                            location can improve clarity. Give a return email
                            address or another easy Internet-based way to allow
                            people to communicate their choice to you. You may
                            create a menu to allow a recipient to opt out of
                            certain types of messages, but you must include the
                            option to stop all commercial messages from you.
                            Make sure your spam filter doesn’t block these
                            opt-out requests.
                          </li>
                          <li>
                            <b>Honor opt-out requests promptly: </b> Any opt-out
                            mechanism you offer must be able to process opt-out
                            requests for at least 30 days after you send your
                            message. You must honor a recipient’s opt-out
                            request within 10 business days. You can’t charge a
                            fee, require the recipient to give you any
                            personally identifying information beyond an email
                            address, or make the recipient take any step other
                            than sending a reply email or visiting a single page
                            on an Internet website as a condition for honoring
                            an opt-out request. Once people have told you they
                            don’t want to receive more messages from you, you
                            can’t sell or transfer their email addresses, even
                            in the form of a mailing list. The only exception is
                            that you may transfer the addresses to a company
                            you’ve hired to help you comply with the CAN-SPAM
                            Act.
                          </li>
                          <li>
                            <b>
                              Monitor what others are doing on your behalf:{" "}
                            </b>{" "}
                            The law makes clear that even if you hire another
                            company to handle your email marketing, you can’t
                            contract away your legal responsibility to comply
                            with the law. Both the company whose product is
                            promoted in the message and the company that
                            actually sends the message may be held legally
                            responsible.
                          </li>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>
                          {" "}
                          Q. How do I know if the CAN-SPAM Act covers email my
                          business is sending?
                        </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        A. What matters is the “primary purpose” of the message.
                        To determine the primary purpose, remember that an email
                        can contain three different types of information:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li>
                            Commercial content – which advertises or promotes a
                            commercial product or service, including content on
                            a website operated for a commercial purpose
                          </li>
                          <li>
                            Transactional or relationship content – which
                            facilitates an already agreed-upon transaction or
                            updates a customer about an ongoing transaction
                          </li>
                          <li>
                            Other content – which is neither commercial nor
                            transactional or relationship
                          </li>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        If the message contains only commercial content, its
                        primary purpose is commercial and it must comply with
                        the requirements of CAN-SPAM. If it contains only
                        transactional or relationship content, its primary
                        purpose is transactional or relationship. In that case,
                        it may not contain false or misleading routing
                        information, but is otherwise exempt from most
                        provisions of the CAN-SPAM Act.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>
                          {" "}
                          Q. How do I know if what I’m sending is a
                          transactional or relationship message?
                        </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        A. The primary purpose of an email is transactional or
                        relationship if it consists only of content that:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li>
                            Facilitates or confirms a commercial transaction
                            that the recipient already has agreed to
                          </li>
                          <li>
                            Gives warranty, recall, safety, or security
                            information about a product or service
                          </li>
                          <li>
                            Gives information about a change in terms or
                            features or account balance information regarding a
                            membership, subscription, account, loan or other
                            ongoing commercial relationship
                          </li>
                          <li>
                            Provides information about an employment
                            relationship or employee benefits
                          </li>
                          <li>
                            Delivers goods or services as part of a transaction
                            that the recipient already has agreed to
                          </li>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>
                          {" "}
                          Q. What if the message combines commercial content and
                          transactional or relationship content?
                        </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        A. It’s common for email sent by businesses to mix
                        commercial content and transactional or relationship
                        content. When an email contains both kinds of content,
                        the primary purpose of the message is the deciding
                        factor. Here’s how to make that determination: If a
                        recipient reasonably interpreting the subject line would
                        likely conclude that the message contains an
                        advertisement or promotion for a commercial product or
                        service or if the message’s transactional or
                        relationship content does not appear mainly at the
                        beginning of the message, the primary purpose of the
                        message is commercial. So, when a message contains both
                        kinds of content – commercial and transactional or
                        relationship – if the subject line would lead the
                        recipient to think it’s a commercial message, it’s a
                        commercial message for CAN-SPAM purposes. Similarly, if
                        the bulk of the transactional or relationship part of
                        the message doesn’t appear at the beginning, it’s a
                        commercial message under the CAN-SPAM Act.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>
                          {" "}
                          Q. What if the message combines elements of both a
                          commercial message and a message with content defined
                          as “other”?
                        </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        A. In that case, the primary purpose of the message is
                        commercial and the provisions of the CAN-SPAM Act apply
                        if:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li>
                            A recipient reasonably interpreting the subject line
                            would likely conclude that the message advertises or
                            promotes a commercial product or service; and
                          </li>
                          <li>
                            A recipient reasonably interpreting the body of the
                            message would likely conclude that the primary
                            purpose of the message is to advertise or promote a
                            product or service.
                          </li>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Factors relevant to that interpretation include the
                        location of the commercial content (for example, is it
                        at the beginning of the message) how much of the message
                        is dedicated to commercial content; and how color,
                        graphics, type size, style, etc., are used to highlight
                        the commercial content.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>
                          {" "}
                          Q. What if the email includes information from more
                          than one company? Who is the “sender” responsible for
                          CAN-SPAM compliance?
                        </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        A. If an email advertises or promotes the goods,
                        services, or websites of more than one marketer, there’s
                        a straightforward method for determining who’s
                        responsible for the duties the CAN-SPAM Act imposes on
                        “senders” of commercial email. Marketers whose goods,
                        services, or websites are advertised or promoted in a
                        message can designate one of the marketers as the
                        “sender” for purposes of CAN-SPAM compliance as long as
                        the designated sender: Meets the CAN-SPAM Act’s
                        definition of “sender,” meaning that they initiate a
                        commercial message advertising or promoting their own
                        goods, services, or website; is specifically identified
                        in the “from” line of the message; and complies with the
                        “initiator” provisions of the Act – for example, making
                        sure the email does not contain deceptive transmission
                        information or a deceptive subject heading, and ensuring
                        that the email includes a valid postal address, a
                        working opt-out link, and proper identification of the
                        message’s commercial or sexually explicit nature. If the
                        designated sender doesn’t comply with the
                        responsibilities the law gives to initiators, all
                        marketers in the message may be held liable as senders.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>
                          {" "}
                          Q. My company sends email with a link so that
                          recipients can forward the message to others. Who is
                          responsible for CAN-SPAM compliance for these “Forward
                          to a Friend” messages?
                        </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        A. Whether a seller or forwarder is a “sender” or
                        “initiator” depends on the facts. So, deciding if the
                        CAN-SPAM Act applies to a commercial
                        “forward-to-a-friend” message often depends on whether
                        the seller has offered to pay the forwarder or give the
                        forwarder some other benefit. For example, if the seller
                        offers money, coupons, discounts, awards, additional
                        entries in a sweepstakes, or the like in exchange for
                        forwarding a message, the seller may be responsible for
                        compliance. Or if a seller pays or gives a benefit to
                        someone in exchange for generating traffic to a website
                        or for any form of referral, the seller is likely to
                        have compliance obligations under the CAN-SPAM Act.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>
                          {" "}
                          Q. What are the penalties for violating the CAN-SPAM
                          Act?
                        </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        A. Each separate email in violation of the law is
                        subject to penalties of up to $41,484, and more than one
                        person may be held responsible for violations. For
                        example, both the company whose product is promoted in
                        the message and the company that originated the message
                        may be legally responsible. Email that makes misleading
                        claims about products or services also may be subject to
                        laws outlawing deceptive advertising, like Section 5 of
                        the FTC Act. The CAN-SPAM Act has certain aggravated
                        violations that may give rise to additional fines. The
                        law provides for criminal penalties – including
                        imprisonment – for:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li>
                            Accessing someone else’s computer to send spam
                            without permission.
                          </li>
                          <li>
                            Using false information to register for multiple
                            email accounts or domain names.
                          </li>
                          <li>
                            Relaying or retransmitting multiple spam messages
                            through a computer to mislead others about the
                            origin of the message.
                          </li>
                          <li>
                            Harvesting email addresses or generating them
                            through a dictionary attack (the practice of sending
                            email to addresses made up of random letters and
                            numbers in the hope of reaching valid ones), and
                            taking advantage of open relays or open proxies
                            without permission.
                          </li>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>
                          {" "}
                          Q. Are there separate rules that apply to sexually
                          explicit email?
                        </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        A. Yes, and the FTC has issued a rule under the CAN-SPAM
                        Act that governs these messages. Messages with sexually
                        oriented material must include the warning
                        “SEXUALLY-EXPLICIT:” at the beginning of the subject
                        line. In addition, the rule requires the electronic
                        equivalent of a “brown paper wrapper” in the body of the
                        message. When a recipient opens the message, the only
                        things that may be viewable on the recipient’s screen
                        are:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li>the words “SEXUALLY-EXPLICIT”; and</li>
                          <li>
                            the same information required in any other
                            commercial email: a disclosure that the message is
                            an ad, the sender’s physical postal address, and the
                            procedure for how recipients can opt out of
                            receiving messages from this sender in the future.
                          </li>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        No graphics are allowed on the “brown paper wrapper.”
                        This provision makes sure that rec ipients cannot view
                        sexually explicit content without an affirmative act on
                        their part – for example, scrolling down or clicking on
                        a link. However, this requirement does not apply if the
                        person receiving the message has already given
                        affirmative consent to receive the sender’s sexually
                        oriented messages.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>Email validation</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We take our anti-spam policy seriously. Prior to
                        distribution, all email addresses are subject to
                        verification. Our email validation software identifies
                        and removes:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li>
                            Invalid emails from your list to prevent email
                            bounces from ruining your deliverability
                          </li>
                          <li>Spam traps and known email complainers</li>
                          <li>Duplicate email addresses.</li>
                          <li>Inactive email addresses.</li>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Your use of Povital’s website and services is subject to
                        this policy. Please note that, in accorda nce with the
                        Povital Acceptable Use Policy, we may change this policy
                        at any time. It is your responsibility to keep
                        up-to-date with and comply with this policy.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>Unsubscribe Link</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Email messages sent from Povital must contain an
                        “unsubscribe” link that allows subscribers to remove
                        themselves from your email messages. You acknowledge and
                        agree that you will not hide, disable, or remove or
                        attempt to hide, disable, or remove the opt-out link
                        from the email invitation. You will actively manage and
                        process unsubscribe requests received by you, and update
                        your email lists and address books to reflect the
                        unsubscribe requests.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>Email Bounce Statistics & Client Restrictions</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Povital uses industry-standard metrics to report on how
                        your emails are performing. You can get insights into
                        the number of emails that are valid, how many have been
                        delivered, and how many have been opened. Opens are a
                        great indicator that your emails are engaging your
                        recipients. This shows that the email is interesting
                        enough to a recipient for them to view. POVITAL strives
                        hard to maintain a 97% delivery rate in most of their
                        email distribution campaigns. However, the results might
                        vary based on the quality of the email address list,
                        type of content, and ISP spam traps of the receivers.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>Automatic Global Unsubscribe</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        A global unsubscribe occurs when a subscriber chooses to
                        unsubscribe from every email sent from Povital. Povital
                        manages this list, so a subscriber’s status changes to
                        Unsubscribed on the global list when they globally
                        unsubscribe. None of our clients can email that
                        subscriber, regardless from what message they clicked
                        the unsubscribe link.
                      </Typography>
                    </Box>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Box>
      <Footer />
    </Box>
  );
};

export default Website;
